import React from 'react'
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core'
import { PrismicRichText } from '@prismicio/react'

type Props = {
  labelRich: any
  name: string
  checked: boolean
  error?: string
  helperText?: string
  onChange: (value: boolean) => void
}

const CheckboxInput: React.FC<Props> = ({
  labelRich,
  name,
  checked,
  error,
  helperText,
  onChange,
}) => {
  return (
    <Box my={2}>
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            color="primary"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={<PrismicRichText field={labelRich} />}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
      {!error && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </Box>
  )
}

export default CheckboxInput
